var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-down"}},[(_vm.errors && _vm.errors.length > 0)?_c('div',{staticClass:"error-text"},_vm._l((_vm.errors),function(error){return _c('div',[_vm._v(_vm._s(error))])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }